import { InsightsApi } from '@insights/insights-data-provider';
import { getDexfApiKey } from '@inter-ikea-storageone/range';
import { getCountry } from 'i18n/i18nUtils';
import React, { useContext } from 'react';
import { MLService } from 'services/MLService';
import { isKiosk, isProduction } from 'utils/platform';
import { getRange } from 'utils/queryUtils';
import { useCookieConsent } from './cookieConsent';
import { withInsights } from './insights';

export const InsightsMLContext = React.createContext<MLService | null>(null);

export const useInsightsML = (): MLService => {
  const context = useContext(InsightsMLContext);

  if (!context) {
    throw new Error(`Insights context must be defined`);
  }

  return context;
};

type Props = {
  children: React.ReactNode;
  insightsApi: InsightsApi;
};

const MLProvider = ({ children, insightsApi }: Props) => {
  const { settings } = useCookieConsent();
  const isDev = !isProduction();

  const mlService = new MLService(
    {
      isKiosk: isKiosk(),
      dev: isDev,
      cookieConsent: !!(settings && settings[2]),
      dexfApiKey: getDexfApiKey(getRange(), isDev),
      countryCode: getCountry()
    },
    insightsApi
  );

  if (!mlService) {
    return null;
  }

  return (
    <InsightsMLContext.Provider value={mlService as MLService}>
      {children}
    </InsightsMLContext.Provider>
  );
};

export const InsightsMLProvider = withInsights(MLProvider);
